export default __webpack_public_path__ + "slices/main/assets/public/media/camper-underlines/new-underline.e1ad610a3c8d6a790c60ee4e98c9e20b.svg";